import * as React from 'react';
import { render } from 'react-dom';
import './index.css';
import LocalizerApp from './LocalizerApp';

render(
  <LocalizerApp />,
  document.getElementById('root')
);